import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import Icon, {Icons, Sizes} from '@pb/kit-component-icon';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './strip-of-pills.module.styl';

import type {FlatButtonProps} from '@pb/kit-component-button';

const classNames = hashedClasses(styles);

export type MoreLessButtonProps = {
    isCollapsed: boolean,
    onChange: (isCollapsed: boolean) => unknown,
    textCollapsed?: string,
    textExpanded?: string,
} & Omit<FlatButtonProps, 'onChange' | 'children'>;


export const MoreLessButton = ({
    isCollapsed,
    onChange,
    textCollapsed = 'More ',
    textExpanded = ' Less',
    ...props
}: MoreLessButtonProps) => {
    return (
        <FlatButton
            startIcon={!isCollapsed ? <Icon type={Icons.ANGLE_LEFT} size={Sizes.Size_14}/> : null}
            endIcon={isCollapsed ? <Icon type={Icons.ANGLE_RIGHT} size={Sizes.Size_14}/> : null}
            className={classNames['inline-button']}
            onClick={() => onChange(!isCollapsed)}
            {...props}>
            {isCollapsed ? textCollapsed : textExpanded}
        </FlatButton>
    );
};
